import { __assign, __extends } from "tslib";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
import { CognitoIdentityProviderServiceException as __BaseException } from "./CognitoIdentityProviderServiceException";
import { AttributeType, UserPoolClientType, } from "./models_0";
export var StartUserImportJobResponse;
(function (StartUserImportJobResponse) {
    StartUserImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartUserImportJobResponse || (StartUserImportJobResponse = {}));
export var StopUserImportJobRequest;
(function (StopUserImportJobRequest) {
    StopUserImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopUserImportJobRequest || (StopUserImportJobRequest = {}));
export var StopUserImportJobResponse;
(function (StopUserImportJobResponse) {
    StopUserImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopUserImportJobResponse || (StopUserImportJobResponse = {}));
export var TagResourceRequest;
(function (TagResourceRequest) {
    TagResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagResourceRequest || (TagResourceRequest = {}));
export var TagResourceResponse;
(function (TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagResourceResponse || (TagResourceResponse = {}));
export var UntagResourceRequest;
(function (UntagResourceRequest) {
    UntagResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UntagResourceRequest || (UntagResourceRequest = {}));
export var UntagResourceResponse;
(function (UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UntagResourceResponse || (UntagResourceResponse = {}));
export var UpdateAuthEventFeedbackRequest;
(function (UpdateAuthEventFeedbackRequest) {
    UpdateAuthEventFeedbackRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Username && { Username: SENSITIVE_STRING })), (obj.FeedbackToken && { FeedbackToken: SENSITIVE_STRING }))); };
})(UpdateAuthEventFeedbackRequest || (UpdateAuthEventFeedbackRequest = {}));
export var UpdateAuthEventFeedbackResponse;
(function (UpdateAuthEventFeedbackResponse) {
    UpdateAuthEventFeedbackResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateAuthEventFeedbackResponse || (UpdateAuthEventFeedbackResponse = {}));
export var UpdateDeviceStatusRequest;
(function (UpdateDeviceStatusRequest) {
    UpdateDeviceStatusRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.AccessToken && { AccessToken: SENSITIVE_STRING }))); };
})(UpdateDeviceStatusRequest || (UpdateDeviceStatusRequest = {}));
export var UpdateDeviceStatusResponse;
(function (UpdateDeviceStatusResponse) {
    UpdateDeviceStatusResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateDeviceStatusResponse || (UpdateDeviceStatusResponse = {}));
export var UpdateGroupRequest;
(function (UpdateGroupRequest) {
    UpdateGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateGroupRequest || (UpdateGroupRequest = {}));
export var UpdateGroupResponse;
(function (UpdateGroupResponse) {
    UpdateGroupResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateGroupResponse || (UpdateGroupResponse = {}));
export var UpdateIdentityProviderRequest;
(function (UpdateIdentityProviderRequest) {
    UpdateIdentityProviderRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateIdentityProviderRequest || (UpdateIdentityProviderRequest = {}));
export var UpdateIdentityProviderResponse;
(function (UpdateIdentityProviderResponse) {
    UpdateIdentityProviderResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateIdentityProviderResponse || (UpdateIdentityProviderResponse = {}));
export var UpdateResourceServerRequest;
(function (UpdateResourceServerRequest) {
    UpdateResourceServerRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateResourceServerRequest || (UpdateResourceServerRequest = {}));
export var UpdateResourceServerResponse;
(function (UpdateResourceServerResponse) {
    UpdateResourceServerResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateResourceServerResponse || (UpdateResourceServerResponse = {}));
export var UpdateUserAttributesRequest;
(function (UpdateUserAttributesRequest) {
    UpdateUserAttributesRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.UserAttributes && {
        UserAttributes: obj.UserAttributes.map(function (item) { return AttributeType.filterSensitiveLog(item); }),
    })), (obj.AccessToken && { AccessToken: SENSITIVE_STRING }))); };
})(UpdateUserAttributesRequest || (UpdateUserAttributesRequest = {}));
export var UpdateUserAttributesResponse;
(function (UpdateUserAttributesResponse) {
    UpdateUserAttributesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateUserAttributesResponse || (UpdateUserAttributesResponse = {}));
export var UpdateUserPoolRequest;
(function (UpdateUserPoolRequest) {
    UpdateUserPoolRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateUserPoolRequest || (UpdateUserPoolRequest = {}));
export var UpdateUserPoolResponse;
(function (UpdateUserPoolResponse) {
    UpdateUserPoolResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateUserPoolResponse || (UpdateUserPoolResponse = {}));
export var UpdateUserPoolClientRequest;
(function (UpdateUserPoolClientRequest) {
    UpdateUserPoolClientRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ClientId && { ClientId: SENSITIVE_STRING }))); };
})(UpdateUserPoolClientRequest || (UpdateUserPoolClientRequest = {}));
export var UpdateUserPoolClientResponse;
(function (UpdateUserPoolClientResponse) {
    UpdateUserPoolClientResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.UserPoolClient && { UserPoolClient: UserPoolClientType.filterSensitiveLog(obj.UserPoolClient) }))); };
})(UpdateUserPoolClientResponse || (UpdateUserPoolClientResponse = {}));
export var UpdateUserPoolDomainRequest;
(function (UpdateUserPoolDomainRequest) {
    UpdateUserPoolDomainRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateUserPoolDomainRequest || (UpdateUserPoolDomainRequest = {}));
export var UpdateUserPoolDomainResponse;
(function (UpdateUserPoolDomainResponse) {
    UpdateUserPoolDomainResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateUserPoolDomainResponse || (UpdateUserPoolDomainResponse = {}));
var EnableSoftwareTokenMFAException = (function (_super) {
    __extends(EnableSoftwareTokenMFAException, _super);
    function EnableSoftwareTokenMFAException(opts) {
        var _this = _super.call(this, __assign({ name: "EnableSoftwareTokenMFAException", $fault: "client" }, opts)) || this;
        _this.name = "EnableSoftwareTokenMFAException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EnableSoftwareTokenMFAException.prototype);
        return _this;
    }
    return EnableSoftwareTokenMFAException;
}(__BaseException));
export { EnableSoftwareTokenMFAException };
export var VerifySoftwareTokenRequest;
(function (VerifySoftwareTokenRequest) {
    VerifySoftwareTokenRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.AccessToken && { AccessToken: SENSITIVE_STRING }))); };
})(VerifySoftwareTokenRequest || (VerifySoftwareTokenRequest = {}));
export var VerifySoftwareTokenResponseType;
(function (VerifySoftwareTokenResponseType) {
    VerifySoftwareTokenResponseType["ERROR"] = "ERROR";
    VerifySoftwareTokenResponseType["SUCCESS"] = "SUCCESS";
})(VerifySoftwareTokenResponseType || (VerifySoftwareTokenResponseType = {}));
export var VerifySoftwareTokenResponse;
(function (VerifySoftwareTokenResponse) {
    VerifySoftwareTokenResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VerifySoftwareTokenResponse || (VerifySoftwareTokenResponse = {}));
export var VerifyUserAttributeRequest;
(function (VerifyUserAttributeRequest) {
    VerifyUserAttributeRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.AccessToken && { AccessToken: SENSITIVE_STRING }))); };
})(VerifyUserAttributeRequest || (VerifyUserAttributeRequest = {}));
export var VerifyUserAttributeResponse;
(function (VerifyUserAttributeResponse) {
    VerifyUserAttributeResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VerifyUserAttributeResponse || (VerifyUserAttributeResponse = {}));
